import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  setPropertyWalkThroughFormStep,
  setPropertyWalkThroughFormPreviousStep,
  setPropertyWalkThroughFormIsVisible,
  setPropertyWalkThroughFormData,
  exitPropertyWalkThroughForm,
  updateSubAreaCheckStatus,
} from '../../../store/actions/propertyWalkThroughForm';
import { selectPropertyWalkThroughFormData } from '../../../store/selectors/propertyWalkThroughForm';
import { selectSuiteById } from '../../../store/selectors/suites';
import { selectAuthenticatedUser } from '../../../store/selectors/auth';
import Row from '../../Row';
import Col from '../../Col';
import Icon from '../../Icon';
import '../../../layouts/WithNavigation/Sidebar.scss';
import './ViewAllAreasAndFloorPlan.scss';
import '../../Heading/Heading.scss';
import './LeftNavigation.scss';
import './SubAreaApprovalForm.scss';
import { selectEasyWalkThroughFormData } from '../../../store/selectors/easyWalkThroughForm';
import {
  setEasyWalkThroughFormData,
  setEasyWalkThroughFormNextStep,
  updateWalkthroughChecklist,
  fetchWalkThroughServiceList,
} from '../../../store/actions/easyWalkThroughForm';
import {
  fetchSubAreaData,
  fetchSuiteCheckList,
  fetchAreaData,
  fetchAreasAndSubAreas,
} from '../../../store/actions/areas';
import {
  fetchAllIssueTypes,
  fetchAllTicketStatus,
} from '../../../store/actions/formOptions';
import Loader from '../../Loader';
import { selectLoader } from '../../../store/selectors/loader';
import { setWalkThroughStatus } from '../../../store/actions/suites';
import 'react-image-lightbox/style.css';
import Overlay from '../../Overlay';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { selectServiceRequests } from '../../../store/selectors/serviceRequests';
import { selectWalkThrough } from '../../../store/selectors/walkThrough';
import { convertImgToBase64 } from '../IndexDB';
import {
  fetchServiceRequestByAssetId,
  saveServiceRequest,
} from '../../../store/actions/serviceRequest';
import { selectCommonIssues } from '../../../store/selectors/CommonIssues';
import { upload } from '../../../helpers/upLoadHelper';
import {
  fetchCommonIssues,
  clearCommonIssues,
} from '../../../store/actions/CommonIssues';
import Marker from '../../AnnotateImage/Marker';
import * as client from '../../../services/client';
import { startLoading, stopLoading } from '../../../store/actions/loader';
import { onCheckHeicDocument } from '../../../helpers/CommonHelpers';
import { serviceRequestTableLocalTime } from '../../../helpers/validationHelper';
import moment from 'moment';
import { fetchServiceRequestTags } from '../../../store/actions/formOptions';
import LogHomeownerIssue from './LogHomeownerIssue';
import WalkthroughChecklistItems from './WalkthroughChecklistItems';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';

class ViewSubAreas extends Component {
  state = {
    showOverlay: false,
    isOpen: false,
    selectedIndex: null,
    itemImage: [],
    assetIcons: [],
    isServiceRequestOpen: false,
    serviceRequestProcessing: false,
    isOpenPopup: false,
    walkthroughServiceRequestsByAsset: [],
    selectedSRId: null,
    showImages: false,
    selectedImages: '',
    issueTypeId: '',
  };

  componentDidMount() {
    const {
      onFetchIssueTypes,
      propertyWalkThroughFormData,
      onFetchSuiteCheckList,
      onFetchAreasAndSubAreas,
      onFetchTicketStatus,
    } = this.props;
    onFetchTicketStatus();
    onFetchAreasAndSubAreas(propertyWalkThroughFormData.walkthroughId);
    onFetchIssueTypes();
    onFetchSuiteCheckList(propertyWalkThroughFormData.walkthroughId);
    this.onSetIssueType();
  }

  onSetIssueType = () => {
    const { onSetEasyWalkThroughFormData, types, user } = this.props;
    if (user.roles[0].role.name === 'Home Owner') {
      let issue = types.filter((item) => item.name === 'General')[0];
      const issueParams = {
        issueType: issue.name,
        issueTypeId: issue.id,
      };
      this.setState({ issueTypeId: issue.id });
      onSetEasyWalkThroughFormData(issueParams);
    } else {
      onSetEasyWalkThroughFormData({ issueTypeId: '' });
    }
  };

  componentDidUpdate(prevProps) {
    const { propertyWalkThroughFormData } = this.props;
    if (
      prevProps.propertyWalkThroughFormData.serviceRequests &&
      prevProps.propertyWalkThroughFormData.serviceRequests.length <
        propertyWalkThroughFormData.serviceRequests.length
    ) {
      this.setState({ serviceRequestProcessing: false });
    }
  }

  handleItemChecked = (item) => {
    const {
      onSetPropertyWalkThroughFormData,
      easyWalkThroughFormData,
      propertyWalkThroughFormData,
      user,
      onUpdateWalkthroughChecklist,
    } = this.props;
    let walkthroughId = propertyWalkThroughFormData.walkthroughId;
    item = { ...item, ischecked: item.ischecked ? false : true };
    let checkedList = propertyWalkThroughFormData.checkList.map((data) => {
      if (data.id === item.id) {
        return item;
      } else {
        return data;
      }
    });

    onSetPropertyWalkThroughFormData({ checkList: checkedList });
    let params = {
      WalkthroughId: walkthroughId,
      UserId: user.id,
      AreaId: easyWalkThroughFormData.areaId,
      UnitId: propertyWalkThroughFormData.suiteId,
      ChecklistItems: checkedList,
    };
    onUpdateWalkthroughChecklist(params);

    if (
      propertyWalkThroughFormData.status === 'Self-Guided Walk Through' ||
      propertyWalkThroughFormData.status === 'In Progress Home Only'
    ) {
      let status = {
        WalkthroughId: propertyWalkThroughFormData.walkthroughId,
        SuiteId: propertyWalkThroughFormData.suiteId,
        UserId: user.id,
        Role: user.roles[0].role.name,
        Signature: '',
        Status: 'In Progress Home Only',
      };
      this.props.setWalkThroughStatus(status);
    } else {
      let status = {
        WalkthroughId: propertyWalkThroughFormData.walkthroughId,
        SuiteId: propertyWalkThroughFormData.suiteId,
        UserId: user.id,
        Role: user.roles[0].role.name,
        Signature: '',
        Status: 'In Progress Home',
      };
      this.props.setWalkThroughStatus(status);
    }
  };

  editBasedRoleAndStatus() {
    const { user, propertyWalkThroughFormData } = this.props;
    let status = propertyWalkThroughFormData.status;
    if (user.roles[0].role.name === 'Home Owner') {
      if (
        status === 'Guided Walk Through' ||
        status === 'Self-Guided Walk Through' ||
        status === 'In Progress Home Only' ||
        status === 'In Progress Home' ||
        status === 'In Progress Home Only' ||
        status === 'Begin' ||
        (propertyWalkThroughFormData.configTypeSaved &&
          propertyWalkThroughFormData.configTypeSaved.scheduledTime === null &&
          status === 'Begin')
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        status === 'Guided Walk Through' ||
        status === 'In Progress Home' ||
        status === 'In Progress Home Only' ||
        status === 'Self-Guided Walk Through' ||
        (propertyWalkThroughFormData.configTypeSaved &&
          propertyWalkThroughFormData.configTypeSaved.scheduledTime === null &&
          status === 'Begin')
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  handleIssueTypeSelected(e) {
    const { types, onSetEasyWalkThroughFormData, onClearCommonIssues } =
      this.props;
    onClearCommonIssues();
    let issue = types.filter((item) => item.id === e.target.value)[0];
    onSetEasyWalkThroughFormData({
      issueType: issue.name,
      issueTypeId: issue.id,
    });
  }

  handleIssueSelected = (e) => {
    const { onSetEasyWalkThroughFormData, commonIssues, user } = this.props;
    let issueData = commonIssues.filter(
      (item) => item.id === e.target.value
    )[0];
    if (user.roles[0].role.name === 'Home Owner') {
      onSetEasyWalkThroughFormData({
        commonIssueId: e.target.value,
        subject: issueData.subject,
        description: issueData.description,
        selectedImage: issueData.attachment
          ? JSON.parse(issueData.attachment)
          : [],
      });
    } else {
      onSetEasyWalkThroughFormData({
        commonIssueId: e.target.value,
        issueTypeId: issueData.issueTypeId,
        subject: issueData.subject,
        description: issueData.description,
        selectedImage: issueData.attachment
          ? JSON.parse(issueData.attachment)
          : [],
      });
    }
  };

  selectMultipleItems = async (files) => {
    const { easyWalkThroughFormData, onSetEasyWalkThroughFormData } =
      this.props;
    if (
      easyWalkThroughFormData.selectedImage &&
      easyWalkThroughFormData.selectedImage.length
    ) {
      let selectedImage = easyWalkThroughFormData.selectedImage;
      for (var i = 0; i < selectedImage.length; i++) {
        if (selectedImage[i].id) {
        } else {
        }
      }
      if (files && files.length > 0) {
        if (
          easyWalkThroughFormData.annotatateImage &&
          easyWalkThroughFormData.annotatateImage === true
        ) {
          onSetEasyWalkThroughFormData({ showImageLoading: true });
          let upLoadedImages = await this.upLoadImage(files);
          let upLoads = [];
          let editedUpLoads = [];
          if (
            easyWalkThroughFormData.editedUpLoadedImages &&
            easyWalkThroughFormData.editedUpLoadedImages.length > 0
          ) {
            editedUpLoads = [
              ...easyWalkThroughFormData.editedUpLoadedImages,
              ...upLoadedImages,
            ];
          }
          upLoads =
            easyWalkThroughFormData.upLoadedImages &&
            easyWalkThroughFormData.upLoadedImages.length > 0
              ? [...easyWalkThroughFormData.upLoadedImages, ...upLoadedImages]
              : upLoadedImages;
          onSetEasyWalkThroughFormData({
            showImageLoading: false,
            upLoadedImages: upLoads,
            editedUpLoadedImages: editedUpLoads,
          });
          this.setState({ showOverlay: true });
        }
        onSetEasyWalkThroughFormData({
          selectedImage: [...files, ...selectedImage],
        });
      }
    } else {
      onSetEasyWalkThroughFormData({ selectedImage: files });
      if (
        easyWalkThroughFormData.annotatateImage &&
        easyWalkThroughFormData.annotatateImage === true
      ) {
        onSetEasyWalkThroughFormData({ showImageLoading: true });
        let upLoadedImages = await this.upLoadImage(files);
        onSetEasyWalkThroughFormData({
          showImageLoading: false,
          upLoadedImages: upLoadedImages,
        });
        this.setState({ showOverlay: true });
      }
    }
  };

  upLoadImage = async (files) => {
    let upLoadedImages = [];
    if (files && files.length > 0) {
      for (var i = 0; i < files.length; i++) {
        let data = await convertImgToBase64(files[i]);
        upLoadedImages.push(data);
      }
      return upLoadedImages;
    }
  };

  async showImages(data) {
    let selectedImage;
    if (data && data.attachment) {
      selectedImage = JSON.parse(data.attachment);
      this.setState({
        selectedImages: selectedImage,
        showImages: true,
        selectedIndex: 0,
      });
    }
  }

  imagesData() {
    const { showImages, selectedImages, selectedIndex } = this.state;

    if (!showImages) {
      return null;
    }

    return (
      <ReusableLightbox
        isOpen={showImages}
        onClose={() => this.setState({ showImages: false })}
        image={selectedImages.length === 1 ? selectedImages[0] : undefined}
        images={selectedImages.length > 1 ? selectedImages : undefined}
        initialIndex={selectedIndex}
        onIndexChange={(index) => this.setState({ selectedIndex: index })}
      />
    );
  }

  handleDelete(item, i) {
    const { easyWalkThroughFormData, onSetEasyWalkThroughFormData } =
      this.props;
    let selectedImage = easyWalkThroughFormData.selectedImage;
    let deletedFiles = easyWalkThroughFormData.deletedFiles
      ? easyWalkThroughFormData.deletedFiles
      : [];
    let upLoadedImages =
      easyWalkThroughFormData.upLoadedImages &&
      easyWalkThroughFormData.upLoadedImages.length > 0
        ? easyWalkThroughFormData.upLoadedImages
        : [];
    let editedUpLoadedImages =
      easyWalkThroughFormData.editedUpLoadedImages &&
      easyWalkThroughFormData.editedUpLoadedImages.length > 0
        ? easyWalkThroughFormData.editedUpLoadedImages
        : [];
    if (item.id) {
      item = { ...item, isDeleted: true };
      deletedFiles = [item, ...deletedFiles];
    }
    selectedImage = easyWalkThroughFormData.selectedImage.filter((data) =>
      data && data.id ? data.id !== item.id : data !== item
    );
    if (
      easyWalkThroughFormData.annotatateImage &&
      easyWalkThroughFormData.annotatateImage === true
    ) {
      if (upLoadedImages && upLoadedImages.length > 0) {
        upLoadedImages = upLoadedImages.filter((a, index) => i !== index);
        if (editedUpLoadedImages && editedUpLoadedImages.length > 0) {
          editedUpLoadedImages = editedUpLoadedImages.filter(
            (a, index) => index !== i
          );
        }
      }
    } else {
      upLoadedImages = [];
      editedUpLoadedImages = [];
    }
    onSetEasyWalkThroughFormData({
      selectedImage: selectedImage,
      upLoadedImages: upLoadedImages,
      editedUpLoadedImages: editedUpLoadedImages,
    });
  }

  onSaveImagesAnotated = (images) => {
    this.props.onSetEasyWalkThroughFormData({ editedUpLoadedImages: images });
  };

  handleSave = async (message) => {
    const {
      easyWalkThroughFormData,
      propertyWalkThroughFormData,
      user,
      onSetEasyWalkThroughFormData,
      onUpdateSubAreaCheckStatus,
      ticketStatus,
    } = this.props;

    let serviceRequestTagging = [];
    let tags =
      easyWalkThroughFormData.tags && easyWalkThroughFormData.tags.length > 0
        ? easyWalkThroughFormData.tags
        : [];
    let srStatus = ticketStatus.filter((item) => item.name == 'Submitted');

    if (tags.length > 0) {
      Promise.all(
        tags.map((tag) => {
          if (tag.__isNew__) {
            serviceRequestTagging = [
              ...serviceRequestTagging,
              { name: tag.value },
            ];
          } else {
            serviceRequestTagging = [
              ...serviceRequestTagging,
              { id: tag.value },
            ];
          }
        })
      );
    }

    let profileImage = [];
    onSetEasyWalkThroughFormData({
      processing: true,
      state: 'Processing your request please wait....',
    });

    if (
      easyWalkThroughFormData.selectedImage &&
      easyWalkThroughFormData.selectedImage.length > 0
    ) {
      onSetEasyWalkThroughFormData({ processing: true });
      if (
        easyWalkThroughFormData.annotatateImage &&
        easyWalkThroughFormData.annotatateImage === true
      ) {
        profileImage =
          easyWalkThroughFormData.editedUpLoadedImages &&
          easyWalkThroughFormData.editedUpLoadedImages.length > 0
            ? easyWalkThroughFormData.editedUpLoadedImages
            : [];
      } else {
        for (var i = 0; i < easyWalkThroughFormData.selectedImage.length; i++) {
          if (
            easyWalkThroughFormData.selectedImage[i] &&
            easyWalkThroughFormData.selectedImage[i].url
          ) {
            profileImage[i] = easyWalkThroughFormData.selectedImage[i].url;
          } else {
          }
          profileImage[i] = await upload(
            easyWalkThroughFormData.selectedImage[i]
          );
        }
      }
      this.props.onSetEasyWalkThroughFormData({ profileImage: profileImage });
    } else {
      this.props.onSetEasyWalkThroughFormData({ profileImage: null });
    }

    if (easyWalkThroughFormData.subArea.assetId) {
      let params = {
        IsServiceRequest: 'Walkthrough',
        WalkthroughId: propertyWalkThroughFormData.walkthroughId,
        property_id: propertyWalkThroughFormData.propertyId,
        propertyId: propertyWalkThroughFormData.propertyId,
        suite_id: propertyWalkThroughFormData.suiteId,
        suiteId: propertyWalkThroughFormData.suiteId,
        creatorId: user.id,
        assetId: easyWalkThroughFormData.subArea.assetId,
        itemId: easyWalkThroughFormData.subArea.itemId
          ? easyWalkThroughFormData.subArea.itemId
          : '',
        issueType: easyWalkThroughFormData.issueType,
        issueTypeId: easyWalkThroughFormData.issueTypeId,
        subject:
          easyWalkThroughFormData.subject &&
          easyWalkThroughFormData.subject.length > 0
            ? easyWalkThroughFormData.subject
            : 'Service Request',
        description: easyWalkThroughFormData.description,
        schedulePreferences:
          'Monday Mornings ( 8 AM - 11 AM ),Monday Afternoons ( 1 PM - 5 PM ),Monday Evenings ( 5 PM - 8 PM )',
        statusName: 'Submitted',
        ticketStatusId: srStatus[0].id,
        assetName: easyWalkThroughFormData?.subArea?.name,
        walkthroughType: propertyWalkThroughFormData.walkthroughType,
        areaName: easyWalkThroughFormData.areaName,
        areaId: easyWalkThroughFormData.areaId,
        walkthroughPermissions: propertyWalkThroughFormData.permissions
          ? propertyWalkThroughFormData.permissions
          : null,
        tags: serviceRequestTagging,
      };
      params.profileImage =
        profileImage && profileImage.length > 0
          ? JSON.stringify(profileImage).toString()
          : '';
      params.Attachment =
        profileImage && profileImage.length > 0
          ? JSON.stringify(profileImage).toString()
          : '';

      this.props.onSaveServiceRequest(params, 'walkthrough');
      message !== 'Addisuue' && this.setState({ isOpenPopup: false });

      message == 'Addisuue'
        ? setTimeout(() => {
            this.getAssetList(easyWalkThroughFormData.subArea);
            this.onSetIssueType();
            this.props.onSetEasyWalkThroughFormData({
              // issueTypeId: user.roles[0].role.name === 'Home Owner'?this.state.issueTypeId:'',
              subject: '',
              description: '',
              selectedImage: [],
              editedUpLoadedImages: [],
              uploadedImages: [],
              commonIssueId: '',
              processing: false,
              state: '',
              tags: [],
            });
          }, 5000)
        : this.props.onSetEasyWalkThroughFormData({
            // issueTypeId: user.roles[0].role.name === 'Home Owner'?this.state.issueTypeId:'',
            subject: '',
            description: '',
            selectedImage: [],
            editedUpLoadedImages: [],
            uploadedImages: [],
            commonIssueId: '',
            processing: false,
            state: '',
            tags: [],
          });
      this.onSetIssueType();
      setTimeout(() => {
        this.props.onFetchAreasAndSubAreas(
          this.props.propertyWalkThroughFormData.walkthroughId
        );
      }, 10000);

      onUpdateSubAreaCheckStatus(
        easyWalkThroughFormData.subArea.id,
        'info',
        propertyWalkThroughFormData.walkthroughId
      );
    }
    let status = {
      WalkthroughId: propertyWalkThroughFormData.walkthroughId,
      SuiteId: propertyWalkThroughFormData.suiteId,
      UserId: user.id,
      Role: user.roles[0].role.name,
      Signature: '',
      Status: 'In Progress Home',
    };
    this.props.setWalkThroughStatus(status);
  };

  getAssetList(subArea) {
    this.props.onSetEasyWalkThroughFormData({
      annotatateImage: true,
    });
    this.props.startLoading();
    client
      .getWalkthroughServiceRequestListByAsset(
        subArea.assetId,
        subArea.walkthroughId
      )
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            this.setState({
              walkthroughServiceRequestsByAsset: responsejson,
              isOpenPopup: true,
            });
            this.props.stopLoading();
          });
        }
      });
  }

  validateExpiry = (subArea) => {
    const { user, onFetchServiceRequestTags } = this.props;
    const startDay = serviceRequestTableLocalTime(moment(), 'suitepage');
    const estimatedInOneYeardaysRemaining = moment(
      subArea.warrantExpiration
    ).diff(startDay, 'days');
    const inOneYeardaysRemaining = estimatedInOneYeardaysRemaining - 1;
    if (
      inOneYeardaysRemaining < 0 &&
      (user.roles[0].role.name === 'Home Owner' ||
        user.roles[0].role.name === 'Occupant')
    ) {
      toast.error(
        ` ⓘ We’re sorry, but ${subArea.name ? subArea.name : 'Selected Asset'} is currently past your warranty end date. Please contact us should you have any questions or concerns regarding your warranty.`,
        { autoClose: 6000, position: 'top-center' }
      );
    } else {
      onFetchServiceRequestTags();
      this.getAssetList(subArea);
    }
  };
  onClearSRData = () => {
    this.setState({ isOpenPopup: false, selectedSRId: null });
    this.props.onSetEasyWalkThroughFormData({
      // issueTypeId: "",
      subject: '',
      description: '',
      selectedImage: [],
      editedUpLoadedImages: [],
      uploadedImages: [],
      commonIssueId: '',
      processing: false,
      state: '',
      tags: [],
    });
    this.onSetIssueType();
  };

  // function to set the selected tags
  setTags = (newValue, actionMeta) => {
    const { onSetEasyWalkThroughFormData } = this.props;
    onSetEasyWalkThroughFormData({
      tags: newValue,
    });
  };

  render() {
    const {
      user,
      propertyWalkThroughFormData,
      easyWalkThroughFormData,
      areas,
      onSetEasyWalkThroughFormData,
      onSetPropertyWalkThroughFormStep,
      onSetPropertyWalkThroughFormData,
      loader,
      onFetchServiceRequestByAssetId,
    } = this.props;
    const { selectedSRId, showImages } = this.state;
    let filteredArea = areas.filter(
      (area) => area.areaId === easyWalkThroughFormData.areaId
    )[0];
    let edit = this.editBasedRoleAndStatus();

    let { selectedIndex, isOpen } = this.state;

    let width = 260 / 100;
    //226/220
    let cwidth = 0;
    let totalchecklist = 0;
    let totalcheckedlist = 0;

    let areasCheckList = [];
    if (
      propertyWalkThroughFormData.sideBarCheckList &&
      propertyWalkThroughFormData.sideBarCheckList.areasCheckList.length > 0
    ) {
      totalcheckedlist =
        propertyWalkThroughFormData.sideBarCheckList.totalCheckedChecklist;
      totalchecklist =
        propertyWalkThroughFormData.sideBarCheckList.totalChecklist;
      areasCheckList =
        propertyWalkThroughFormData.sideBarCheckList.areasCheckList;
      if (
        propertyWalkThroughFormData.sideBarCheckList.totalCheckedChecklist !== 0
      ) {
        if (totalcheckedlist === totalchecklist) {
          cwidth = width * 103;
        } else {
          let totalCount =
            (propertyWalkThroughFormData.sideBarCheckList
              .totalCheckedChecklist /
              propertyWalkThroughFormData.sideBarCheckList.totalChecklist) *
            100;

          width = width * totalCount;
          cwidth = width;
        }
      }
    }
    const roleName = user.roles[0].role.name;
    return (
      <div class="main_section">
        {easyWalkThroughFormData.showImageLoading === true ||
        this.state.serviceRequestProcessing ? (
          <Loader center={true} />
        ) : null}

        <div class="right_part_box">
          <div class="dummy_name">
            <div class="dummy_name_title">
              <div class="dummy_name_main">
                <h6
                  onClick={() => {
                    onSetPropertyWalkThroughFormStep(1);
                    onSetPropertyWalkThroughFormData({
                      selectedArea: filteredArea.name,
                      subAreaId: filteredArea.id,
                      type: 'Area',
                      selectedAreaId: filteredArea.areaId,
                      subAreaName: filteredArea.customLabel
                        ? filteredArea.customLabel
                        : filteredArea.name,
                      checkListValue: '',
                    });
                  }}
                >
                  {filteredArea.customLabel
                    ? filteredArea.customLabel
                    : filteredArea.name}{' '}
                  {roleName !== 'Home Owner' && (
                    <svg
                      width="23"
                      height="23"
                      viewBox="0 0 23 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 4H3C2.46957 4 1.96086 4.21071 1.58579 4.58579C1.21071 4.96086 1 5.46957 1 6V20C1 20.5304 1.21071 21.0391 1.58579 21.4142C1.96086 21.7893 2.46957 22 3 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V13"
                        stroke="#A6A6A6"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17.5 2.50001C17.8978 2.10219 18.4374 1.87869 19 1.87869C19.5626 1.87869 20.1022 2.10219 20.5 2.50001C20.8978 2.89784 21.1213 3.4374 21.1213 4.00001C21.1213 4.56262 20.8978 5.10219 20.5 5.50001L11 15L7 16L8 12L17.5 2.50001Z"
                        stroke="#A6A6A6"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  )}
                </h6>
              </div>
            </div>
          </div>
          {loader === false ? (
            <div class="master_bedroom">
              <div class="wich_boxis">
                <div class="right_part_section">
                  {propertyWalkThroughFormData.checkList &&
                    propertyWalkThroughFormData.checkList.length > 0 && (
                      <WalkthroughChecklistItems
                        checkList={propertyWalkThroughFormData.checkList}
                        edit={edit}
                        handleItemChecked={(item) =>
                          this.handleItemChecked(item)
                        }
                      />
                    )}
                  <>
                    {filteredArea.subAreas.length > 0
                      ? filteredArea.subAreas.map((subArea) => {
                          return (
                            <div class="electric_item_box">
                              <div class="upper_part">
                                <div class="electric_item_img">
                                  <img
                                    style={
                                      subArea.itemTypeIcons &&
                                      subArea.itemTypeIcons.icon
                                        ? {}
                                        : { height: '40px', width: '40px' }
                                    }
                                    src={
                                      subArea.itemTypeIcons &&
                                      subArea.itemTypeIcons.icon
                                        ? `/assets/itemImages/${subArea.itemTypeIcons.icon}`
                                        : `/assets/itemImages/no-img-avil.jpg`
                                    }
                                  />
                                </div>
                                <p className="asset">
                                  {subArea.customLabel
                                    ? subArea.customLabel
                                    : subArea.name}
                                </p>
                              </div>
                              <div
                                class="lower_part"
                                onClick={() => {
                                  onSetEasyWalkThroughFormData({
                                    subArea: subArea,
                                  });
                                  onFetchServiceRequestByAssetId(
                                    subArea.assetId,
                                    propertyWalkThroughFormData.walkthroughId
                                  );
                                  if (subArea && subArea.itemId) {
                                    this.props.fetchCommonIssues(
                                      subArea.itemId
                                    );
                                  }
                                }}
                              >
                                <div
                                  class="area_status_text"
                                  onClick={() => this.validateExpiry(subArea)}
                                >
                                  <h5>Log Issue</h5>
                                  <div
                                    style={{
                                      color: '#FF6347',
                                      marginLeft: '5px',
                                    }}
                                  >
                                    {subArea.issuesCreated > 0 && (
                                      <Icon
                                        glyph="exclamation"
                                        weight="light"
                                        size="medium"
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : null}
                  </>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <Row mdCenter>
                <Col>
                  <Loader center={true} />
                </Col>
              </Row>
            </div>
          )}
          {this.state.isOpenPopup && (
            <LogHomeownerIssue
              onClearSRData={this.onClearSRData}
              walkthroughServiceRequestsByAsset={
                this.state.walkthroughServiceRequestsByAsset
              }
              selectedSRId={this.state.selectedSRId}
              onSetSelectedSRId={(id) => this.setState({ selectedSRId: id })}
              commonIssues={this.props.commonIssues}
              onShowImages={(data) => this.showImages(data)}
              types={this.props.types}
              roleName={this.props.user.roles[0].role.name}
              easyWalkThroughFormData={easyWalkThroughFormData}
              onHandleIssueSelected={(e) => this.handleIssueSelected(e)}
              onHandleIssueTypeSelected={(e) => this.handleIssueTypeSelected(e)}
              onSetDescription={(e) =>
                onSetEasyWalkThroughFormData({
                  description: e.target.value,
                })
              }
              onSelectMultipleItems={(files) =>
                onCheckHeicDocument(files) && this.selectMultipleItems(files)
              }
              onHandleDelete={(data, i) => this.handleDelete(data, i)}
              onHandleSave={(message) => this.handleSave(message)}
              onServiceRequestProcessing={(value) =>
                this.setState({
                  serviceRequestProcessing: value,
                })
              }
              setTags={(newValue, actionMeta) =>
                this.setTags(newValue, actionMeta)
              }
            />
          )}
          {showImages === true ? <>{this.imagesData()}</> : null}
        </div>
        <Overlay
          showOverlay={this.state.showOverlay}
          content={
            <Marker
              onClose={() => this.setState({ showOverlay: false })}
              images={
                this.props.easyWalkThroughFormData.editedUpLoadedImages &&
                this.props.easyWalkThroughFormData.editedUpLoadedImages.length >
                  0
                  ? this.props.easyWalkThroughFormData.editedUpLoadedImages
                  : this.props.easyWalkThroughFormData.upLoadedImages
              }
              onSaveImagesAnotated={(images) => {
                this.onSaveImagesAnotated(images);
                this.setState({ showOverlay: false });
              }}
            />
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let propertyWalkThroughFormData = selectPropertyWalkThroughFormData(state);
  let easyWalkThroughFormData = selectEasyWalkThroughFormData(state);
  let suite = selectSuiteById(state, propertyWalkThroughFormData.suiteId);
  let serviceRequests = selectServiceRequests(state);

  return {
    suite,
    easyWalkThroughFormData,
    propertyWalkThroughFormData,
    user: selectAuthenticatedUser(state),
    areas: state.areas,
    loader: selectLoader(state),
    serviceRequests,
    suiteWalkthrough: selectWalkThrough(state),
    types: state.formOptions.types,
    commonIssues: selectCommonIssues(state),
    ticketStatus: state.formOptions.ticketStatus,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onSetEasyWalkThroughFormNextStep: setEasyWalkThroughFormNextStep,
      onSetEasyWalkThroughFormData: setEasyWalkThroughFormData,

      onSetPropertyWalkThroughFormData: setPropertyWalkThroughFormData,
      startLoading,
      stopLoading,
      onUpdateWalkthroughChecklist: updateWalkthroughChecklist,
      onSetPropertyWalkThroughFormPreviousStep:
        setPropertyWalkThroughFormPreviousStep,
      onSetPropertyWalkThroughFormStep: setPropertyWalkThroughFormStep,
      onSetPropertyWalkThroughFormIsVisible:
        setPropertyWalkThroughFormIsVisible,
      onFetchSubAreaData: fetchSubAreaData,
      onFetchIssueTypes: fetchAllIssueTypes,
      onFetchSuiteCheckList: fetchSuiteCheckList,
      setWalkThroughStatus: setWalkThroughStatus,
      onExitPropertyWalkThroughForm: exitPropertyWalkThroughForm,
      onFetchAreaData: fetchAreaData,
      onFetchAreasAndSubAreas: fetchAreasAndSubAreas,
      onFetchWalkThroughServiceList: fetchWalkThroughServiceList,
      onFetchServiceRequestByAssetId: fetchServiceRequestByAssetId,
      onClearCommonIssues: clearCommonIssues,
      onSaveServiceRequest: saveServiceRequest,
      onUpdateSubAreaCheckStatus: updateSubAreaCheckStatus,
      fetchCommonIssues,
      onFetchTicketStatus: fetchAllTicketStatus,
      onFetchServiceRequestTags: fetchServiceRequestTags,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewSubAreas);
